

























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManagementTerritorialAreas extends Vue {
  loading = false;

  menu = [
    {
      title: "Piani operativi inviati",
      subtitle: "",
      to: "/operational-plans-sent",
      type: "",
    },
    {
      title: "Validazione iniziative",
      subtitle: "",
      to: "/iniziative-validations",
      type: "",
    },
  ];

  onSurveyTypeClick(to: string, type = "") {
    if (type !== "link") {
      this.$router.push(to).catch(error => console.log(error));
    } else {
      window.open(to, "_blank");
    }
  }
}
